import { Variable } from '@optimus-web/common';

export enum ProgressMode {
    Determinate = 'determinate',
    Indeterminate = 'inderterminate',
}

export const linearProgressVariants = ['primary', 'success', 'error', 'warning'] as const;
export type LinearProgressVariants = (typeof linearProgressVariants)[number];

export interface LinearProgressProps extends Variable<LinearProgressVariants> {
    mode?: ProgressMode;
    value?: number;
    max?: number;
    min?: number;
    disabled?: boolean;
}

export interface LinearValueBarProps extends Variable<LinearProgressVariants> {
    disabled?: boolean;
    mode?: ProgressMode;
    scale?: number;
}

export interface PasswordRequirementData {
    id: string;
    label: React.ReactNode;
    validate: (password: string) => boolean;
}

export enum PasswordStrength {
    None = 0,
    Weak = 1,
    Normal = 2,
    Good = 3,
}
